import React from 'react';
import { useTranslation } from 'react-i18next';

import { AlertModal } from 'src/legacy/components/Modals';

import { ChannelType } from './useChannelForm';

interface ChannelDeleteConfirmationModalProps {
  channelType: ChannelType;
  onSuccess: () => void;
  onClose: () => void;
}

export const ChannelDeleteConfirmationModal: React.FC<
  ChannelDeleteConfirmationModalProps
> = ({ channelType, onSuccess, onClose }) => {
  const { t } = useTranslation();

  const getText = (): { title: string; body: string; buttonLabel: string } => {
    switch (channelType) {
      case 'messaging':
        return {
          title: t(($) => $.page_channels.confirm_delete_modal.messaging.title),
          body: t(($) => $.page_channels.confirm_delete_modal.messaging.body),
          buttonLabel: t(($) => $.common.delete),
        };
      case 'fileChannel':
        return {
          title: t(
            ($) => $.page_channels.confirm_delete_modal.fileChannel.title,
          ),
          body: t(($) => $.page_channels.confirm_delete_modal.fileChannel.body),
          buttonLabel: t(($) => $.common.delete),
        };
      case 'extension':
        return {
          title: t(($) => $.page_channels.confirm_delete_modal.extension.title),
          body: t(($) => $.page_channels.confirm_delete_modal.extension.body),
          buttonLabel: t(($) => $.common.delete),
        };
      default:
        return {
          title: '',
          body: '',
          buttonLabel: '',
        };
    }
  };

  const { title, body, buttonLabel } = getText();

  return (
    <AlertModal
      title={title}
      open
      onSuccess={onSuccess}
      onClose={onClose}
      successButtonLabel={buttonLabel}
      noCancelButton={false}
    >
      {body}
    </AlertModal>
  );
};
